(function () {
    'use strict';

    run.admin.pages.accountPlanDashboard = function () {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;

        const propertiesEl = document.getElementById('properties');

        const buttons_get_plan = document.querySelectorAll('.plan_get_new');
        for (let i = 0; i < buttons_get_plan.length; i++) {
            buttons_get_plan[i].addEventListener('click', function(e) {
                getPlan(e.target);
            });
        }

        function getPlan(el)
        {
            // Swal.fire({
            //     title: 'Confirm',
            //     html: 'Get plan',
            //     showCloseButton: false,
            //     showCancelButton: true,
            //     showConfirmButton: true,
            //     focusCancel: true,
            //     cancelButtonText: 'Cancel',
            //     confirmButtonText: 'Get',
            //     buttonsStyling: false,
            //     reverseButtons: true,
            //     customClass: {
            //         cancelButton: 'btn btn-lg btn-light',
            //         confirmButton: 'btn btn-lg btn-primary ml-4'
            //     },
            //     showClass: {
            //         popup: 'animate__animated animated__fast animate__fadeInUp'
            //     },
            //     hideClass: {
            //         popup: 'animate__animated animated__fast animate__fadeOutDown'
            //     }
            // }).then((result) => {
            //     if (!result.value) {
            //         return;
            //     }

                for (let i = 0; i < buttons_get_plan.length; i++) {
                    buttons_get_plan[i].addEventListener('click', function(e) {
                        e.target.setAttribute('disabled', 'disabled');
                    });
                }

                el.innerText = el.dataset.textLoading;

                var data = new FormData();
                data.append('csrf_name', csrf_name);
                data.append('csrf_value', csrf_value);
                data.append('plan_slug', el.dataset.planSlug);
                data.append('stage', el.dataset.stage);

                axios.post(GlobalRoutes.plan.createNewViaStripe, data)
                .then(function (response) {
                    var stripe = Stripe(propertiesEl.dataset.stripeKey);
                    stripe.redirectToCheckout({ sessionId: response.data.data.session_id });
                })
                .catch(function (error) {
                    new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                    for (let i = 0; i < buttons_get_plan.length; i++) {
                        buttons_get_plan[i].addEventListener('click', function(e) {
                            e.target.removeAttribute('disabled');
                        });
                    }
    
                    el.innerText = el.dataset.textOriginal;
                });
            // });
        }
    };
})();